export * from './Tabs';
export { default } from './Tabs';
export { default as TabPanel } from './TabPanel';
export { default as TabList } from './TabList';
export { default as Tab } from './Tab';
//# sourceMappingURL=index.js.map